import videojs from 'video.js';

import './overlay.css';

/**
 * @enum {string}
 **/
export const OverlayPosition = Object.freeze({
    TopLeft: 'top-left',
    TopRight: 'top-right',
    BottomLeft: 'bottom-left',
    BottomRight: 'bottom-right',
    Center: 'center'
});

export default class Overlay extends videojs.getComponent('Component') {
    /**
     * 
     * @param {videojs.Player} player
     * @param {Object} options
     * @param {string} options.text
     * @param {OverlayPosition} [options.position]
     * @param {string} [options.className]
     */
    constructor(player, options) {
        super(player, options);
    }

    createEl(tag, props = {}, attributes = {}) {
        const options = this.options();
        const overlayClassPosition = options.position ?? OverlayPosition.Center;

        tag = options.url ? 'a' : 'div';
        props = Object.assign({
            textContent: options.text,
            className: `mediasite-player__overlay mediasite-player__overlay--${overlayClassPosition} ${options.className ?? ''}`.trim()
        });

        if (options.url) {
            props.href = options.url;
            props.target = '_blank';
        }

        return super.createEl.call(this, tag, props, attributes);
    }
}
